module.exports = __webpack_public_path__ + "img/from_toeicTest_content01.5e61dc0c.svg";